/** Mirrors backend/schemas.py COLLAB_MESSAGE_MAX — keep in lockstep. One cap for every free-text
 *  message in the review loop: reason for change, send-back note, per-change comment, discussion
 *  comment/reply, approve reason, promote reason. */
export const COLLAB_MESSAGE_MAX = 2000;

/** Mirrors backend vault_uploads.MAX_BYTES: the working copy is re-uploaded whole on every save,
 *  through the app, so it stays bounded. Checked BEFORE sending so the editor can say the real
 *  size and cause instead of bouncing off the server with an upload message. */
export const WORKING_COPY_MAX_BYTES = 50 * 1024 * 1024;

/** A single pasted / dropped picture. Copying an image from a web page pastes a decoded PNG that
 *  can be 3–4× the original file; we re-encode first, and refuse what is still over this. Large
 *  enough for any figure in a submission; five of them still fit a 50 MB document. */
export const PASTE_IMAGE_MAX_BYTES = 10 * 1024 * 1024;

/** Mirrors backend vault_uploads.FOLDER_NAME_MAX (the VaultFolder.name column is String(120)) —
 *  keep in lockstep. Every box someone TYPES a folder name into carries it, so the limit is
 *  visible before the save rather than discovered as a silently shortened name. Names that come
 *  from a filesystem — a zip's path segments, a folder upload — are trimmed server-side instead;
 *  failing a whole import over one deep name loses more than it protects. */
export const VAULT_FOLDER_NAME_MAX = 120;

/** How many rows every "Load more" in the vault adds — All files, the vault root, a folder's
 *  files, and a folder's subfolders. ONE value on purpose: the three lists used to page at 10,
 *  25 and 15, so the same gesture did a different thing depending on which screen you were on.
 *  15 rather than more because a folder's subfolder list sits ABOVE its files — a taller block
 *  of folders pushes the folder's actual contents off screen. */
export const VAULT_PAGE_SIZE = 15;

/** Mirrors backend routers/vault.py SEARCH_MAX — keep in lockstep.
 *
 *  A search term is not stored, so nothing overflows; the cap is about the QUERY. It reaches a
 *  LIKE across every document the customer has, and an unbounded string is an unbounded scan.
 *  100 characters is far past any real search — a document number is a dozen, a filename a few
 *  dozen — so the limit is invisible in use and only stops a paste or a script. */
export const VAULT_SEARCH_MAX = 100;
